var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-main',[(
      _vm.items && _vm.items.quizzs.length && _vm.items.quizzs[0].department === 'TIN'
    )?_c('stepper-tin',{attrs:{"questions":_vm.items.quizzs[0].questions,"filieres":_vm.items.quizzs[0].filieres}}):_vm._e(),(
      _vm.items && _vm.items.quizzs.length && _vm.items.quizzs[0].department === 'TIC'
    )?_c('stepper-tic',{attrs:{"questions":_vm.items.quizzs[0].questions,"filieres":_vm.items.quizzs[0].filieres}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }